export default "__VITE_ASSET__DczMs1RR__"